<template>
  <div class="choice-character__validate">
    <div v-if="getPlayer">
      <h2 class="title">Félicitations {{ getPlayer.name }}</h2>
      <img :src="getPlayer.img" :alt="getPlayer.name">

      <div class="choice-character__validate-sentences">
        <p v-html="getPlayer.validate['1']"></p>
        <p v-html="getPlayer.validate['2']"></p>
      </div>

      <div class="choice-character__validate-action">
        <router-link to="choisir-son-personnage-slide" class="validate-action-back btn">
          <span></span> Changer de joueur
        </router-link>

        <router-link to="jeu" class="validate-action-continue btn">
          Commencer l'aventure
        </router-link>
      </div>
    </div>
  </div>
</template>

<script>
  import Transition from '~mixins/Transition';

  export default {
    name: 'choice-character-validate',
    mixins: [Transition],
    computed: {
      getPlayer() {
        return this.$store.getters.getPlayer;
      },
    },
  };
</script>


<style lang="scss">
  .choice-character__validate {
    width: 100%;

    @include mobile {
      padding-bottom: 30px;
    }

    h2 {
      text-align: center;
      margin-bottom: 50px;
    }

    img {
      display: block;
      margin: auto;
      max-width: 150px;
      opacity: 0;
      animation: appearBottom .4s ease-in-out forwards;

      @include mobile {
        display: none;
      }
    }

    .choice-character__validate-sentences {
      margin-top: 50px;
      text-align: center;
      color: $blue;
      opacity: 0;
      animation: appearBottom .4s .1s ease-in-out forwards;
      @include fontSize(18);

      p {
        display: block;
        max-width: 90%;
        margin: auto;

        &:first-child {
          font-weight: 600;
          margin-bottom: 20px;
        }
      }
    }
  }

  .choice-character__validate-action {
    display: flex;
    justify-content: center;
    align-items: center;
    flex-direction: row reverse;
    margin-top: 30px;
    opacity: 0;
    animation: appearBottom .4s .2s ease-in-out forwards;

    @include mobile {
      flex-wrap: wrap;
      flex-direction: column-reverse;

      a {
        display: block;
        width: 100%;
      }
    }

    a {
      display: inline-block;
      text-decoration: none;

      @include mobile {
        display: block;
        text-align: center;
      }
    }

    .validate-action-continue {
      background: $orange;
      color: $white;
      padding: 8px 30px;
      text-transform: uppercase;
      border-color: $orange;
      @include fontSize(18);

      @include mobile {
        text-align: center;
        padding: 8px 20px;
        margin-bottom: 30px;
      }

      &:hover {
        background: $white;
        color: $orange;
      }
    }
  }

  .validate-action-back {
    position: relative;
    margin-right: 30px;
    padding: 8px 30px;
    @include fontSize(18);

    @include mobile {
      margin-right: 0;
      margin-bottom: 20px;
    }

    span {
      display: inline-block;
      vertical-align: middle;
      position: relative;
      top: -2px;
      width: 15px;
      height: 15px;
      border-left: 2px solid $orange;
      border-bottom: 2px solid $orange;
      transform: rotate(45deg);
      margin-right: 10px;
      @include defaultTransition(.4);
    }

    &:hover span {
      border-color: $white;
    }
  }
</style>



// WEBPACK FOOTER //
// ChoiceCharacterValidate.vue?8b99386e